// Canonical UI catalog. Country aliases are owned and normalized by the API.
export const COUNTRIES: readonly string[] = [
  'Australia', 'Austria', 'Bahrain', 'Belgium', 'Bulgaria', 'Canada', 'China', 'Croatia',
  'Cyprus', 'Czech Republic', 'Denmark', 'Egypt', 'Estonia', 'Finland', 'France', 'Germany',
  'Greece', 'Hong Kong', 'Hungary', 'India', 'Ireland', 'Italy', 'Japan', 'Korea',
  'Kuwait', 'Latvia', 'Lithuania', 'Luxembourg', 'Malaysia', 'Malta', 'Mexico', 'Netherlands',
  'New Zealand', 'Norway', 'Oman', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar',
  'Romania', 'Saudi Arabia', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'Spain', 'Sweden',
  'Switzerland', 'Taiwan', 'Thailand', 'UAE', 'United Kingdom', 'United States', 'Vietnam',
].sort();
